<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3 v-if="!items.length > 0">Você não possui banners ativos</h3>
            <h3 v-if="items.length > 0">Você possui {{ items.length }} banner{{ items.length > 1 ? "s" : ""}} ativo{{ items.length > 1 ? "s" : ""}}</h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="redirect"
            >
              <i class="fa fa-plus fa-xl"></i>
              Adicionar banner
            </b-button>
            <b-button
              variant="primary"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="alterarOrdem"
              :disabled="!(items.length > 1)"
            >
              <i class="fa fa-cloud fa-xl"></i>
              Salvar ordem
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="items.length > 0" class="mt-3">
      <table class="table table-striped table-bordered" style="background:white;">
        <thead>
          <tr>
            <th scope="col">Ordem</th>
            <th scope="col">Imagem</th>
            <th scope="col">Data Criação</th>
          </tr>
        </thead>
        <draggable v-model="items" tag="tbody" @update="atualizarItens">
          <tr v-for="item in items" :key="item.urlfoto" @click="abrirModal(item)">
            <td scope="row" class="center-text">{{ item.ordem }}</td>
            <td>
              <img :src="item.urlthumbnail" alt="Foto" class="center-image h-80px" />
            </td>
            <td class="center-text">{{ moment(item.createdAt).format("DD/MM/YYYY HH:mm:ss") }}</td>
          </tr>
        </draggable>
      </table>
    </b-card>
    <b-card v-else>
      <center>
        <div>
          <i class="fa fa-frown-o fa-custom-size"></i>
          <h4>Desculpe, não encontramos nenhum banner :(</h4>
          <h5>Para cadastrar, clique no botão acima e comece!</h5>
        </div>
      </center>
    </b-card>
    <b-modal ref="modal" centered hide-footer title="Opções">
      <b-row>
        <b-col xl="6" lg="6" md="6" sm="12">
          <div class="centerModal" @click="editar">
            <i class="fa fa-pencil-square fa-4x"></i>
            <span class="span-card">Editar</span>
          </div>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12">
          <div class="centerModal" @click="excluirBanner">
            <i class="fa fa-times fa-4x"></i>
            <span class="span-card">Excluir</span>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import ImageItem from "./ImageItem";
import axios from "axios";
import * as config from "@/config.json";
import draggable from "vuedraggable";
import Loading from "vue-loading-overlay";


export default {
  components: { draggable, Loading, ImageItem },
  data: _ => {
    return {
      isLoading: false,
      items: [],
      fields: [],
      idBannerSelecionado: null,
      urlBannerSelecionado: null
    };
  },
  methods: {
    abrirModal(i) {
      this.idBannerSelecionado = i.id;
      this.urlBannerSelecionado = i.urlfoto;
      this.redirectBannerSelecionado = i.redirecionar;
      this.$refs.modal.show();
    },
    editar() {
      localStorage.setItem("editar_banner", "true");
      localStorage.setItem("url_banner", this.urlBannerSelecionado);
      localStorage.setItem("redirect_banner", this.redirectBannerSelecionado);
      localStorage.setItem("id_banner", this.idBannerSelecionado);
      this.$router.push(`/banner/editar`);
    },
    async excluirBanner() {
      this.$refs.modal.hide();
      const options = {
        title: "Excluir banner",
        cancelLabel: "Cancelar",
        okLabel: "Sim"
      };
      await this.$dialogs
        .confirm("Confirma excluir este banner?", options)
        .then(async res => {
          if (res.ok == true) {
            await axios
              .delete(
                `${config.default.servidor}/gerencial/banner/${this.idBannerSelecionado}`,
                {
                  headers: {
                    Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                  }
                }
              )
              .then(response => {
                if (response.status == 200) {
                  const options = { title: "Aviso", size: "sm" };
                  this.$dialogs
                    .alert("O banner foi excluido com sucesso.", options)
                    .then(res2 => {});
                  this.getItems();
                }
              })
              .error(error => {
                alert(error);
              });
          }
        });
    },
    redirect() {
      this.$router.push(`/banner/adicionar`);
    },
    async alterarOrdem() {
      var arrayTratado = [];
      for (let i = 0; i < this.items.length; i++) {
        const e = this.items[i];
        arrayTratado.push({
          id: e.id,
          ordem: i + 1
        });
      }
      await axios
        .post(
          `${config.default.servidor}/gerencial/banner/ord`,
          {
            array: arrayTratado
          },
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            let toast = this.$toasted.show("Ordens alteradas com sucesso!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
          }
        });
      setTimeout(() => {
        this.getItems();
      }, 100);
    },
    async getItems() {
      this.isLoading = true;
      await axios
        .get(
          `${config.default.servidor}/gerencial/banner/${localStorage.getItem(
            "enterprise_id"
          )}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.items = response.data.data;
          }
        });
      this.isLoading = false;
    },
    atualizarItens() {
      for (let i = 0; i < this.items.length; i++) {
        const e = this.items[i];
        e.ordem = i + 1;
      }
    }
  },
  async beforeMount() {
    localStorage.removeItem("editar_banner");
    localStorage.removeItem("url_banner");
    localStorage.removeItem("redirect_banner");
    localStorage.removeItem("id_banner");
    await this.getItems();
    this.atualizarItens();
  }
};
</script>